module.exports = __webpack_public_path__ + "static/media/wide.2db74fe0.jpg";